module.exports = __webpack_public_path__ + "img/Medieval_Sword_Katana.e64ef1b0.png";